import React from 'react';
import type { PredictedImpact } from '../types';

const BusinessImpact: React.FC<{ predicted: PredictedImpact; narrative: string }> = ({ predicted, narrative }) => (
  <section className="py-4 border-b border-slate-200">
    <div className="flex items-baseline justify-between mb-3 flex-wrap gap-2">
      <h3 className="text-[13px] font-semibold text-slate-900">改善後の事業インパクト</h3>
      <span className="text-[11px] text-slate-500">業界平均値ベースの試算</span>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-3 mb-4 pb-4 border-b border-slate-100">
      <div>
        <div className="text-[11px] text-slate-500 mb-1">マップ順位（目標）</div>
        <div className="text-xl font-semibold text-leaf-700 leading-none tabular-nums">
          {predicted.current_rank} 位 → {predicted.target_rank} 位
        </div>
        <div className="text-[11px] text-slate-500 mt-1">3-pack 圏内達成</div>
      </div>
      <div>
        <div className="text-[11px] text-slate-500 mb-1">表示回数</div>
        <div className="text-xl font-semibold text-brand-700 leading-none tabular-nums">×{predicted.impression_multiplier}</div>
        <div className="text-[11px] text-slate-500 mt-1">3位以内達成時の業界平均</div>
      </div>
      <div>
        <div className="text-[11px] text-slate-500 mb-1">月間問い合わせ増</div>
        <div className="text-xl font-semibold text-amber-700 leading-none tabular-nums">
          +{predicted.inquiry_lift_min}〜{predicted.inquiry_lift_max} 件
        </div>
        <div className="text-[11px] text-slate-500 mt-1">パーソナルジム平均</div>
      </div>
    </div>

    <h4 className="text-[11px] font-semibold text-slate-700 mb-1">想定売上インパクト</h4>
    <p className="text-[12px] text-slate-700 leading-relaxed whitespace-pre-line">{narrative}</p>
    <div className="text-[10px] text-slate-400 mt-2">
      試算前提: 顧客単価 ¥25,000/月、入会率10%（業界平均）
    </div>
  </section>
);

export default BusinessImpact;
